import { PASSWORD_MATCHES } from '@uplift/constants';
import { L10NShape } from '@uplift/services';
import { boolean, ObjectSchema, object, string } from 'yup';
import { isValidEmail } from '@uplift/validations';

export type InviteForm = {
  email: string;
  password: string | null;
  onboardingTermsAccepted: boolean;
};

export const getInviteFormValidation = (l10n: L10NShape, salesforceCredentialingEnabled: boolean): ObjectSchema<InviteForm> => object({
  email: string()
    .email(l10n.validations.invalidEmail)
    .test('ascii-email', l10n.validations.validEmailOnly, isValidEmail)
    .required(l10n.validations.loginForm.emailBlank),
  password: string()
    .nullable()
    .max(125, l10n.validations.passwordMax)
    .required(l10n.validations.requiredPass)
    .matches(PASSWORD_MATCHES, l10n.validations.passwordMatches),
  onboardingTermsAccepted: salesforceCredentialingEnabled
    ? boolean().oneOf([ true ]).required()
    : boolean().notRequired(),
});
